import React from 'react';
import './Hero.scss';

export interface SecondaryContentProps {
  children: React.ReactNode | React.ReactNode[];
}

const SecondaryContent: React.FC<SecondaryContentProps> = ({ children }: SecondaryContentProps) => {
  return <div className="mss-hero__content">{children}</div>;
};

export default SecondaryContent;
